var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLections = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63.792,
    height: 63.792,
    viewBox: "0 0 63.792 63.792",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unlimited",
    transform: "translate(0.667 0.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Small_Unlimited",
    "data-name": "Icon/Small/Unlimited",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-1-link",
    transform: "translate(6.613 6.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M6.981,0H3.49A3.49,3.49,0,0,0,0,3.49V45.374a3.49,3.49,0,0,0,3.49,3.49H45.374a3.49,3.49,0,0,0,3.49-3.49v-3.49",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1-link-2",
    "data-name": "path-1-link",
    transform: "translate(6.981 6.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1-2",
    "data-name": "path-1",
    d: "M6.981,0H3.49A3.49,3.49,0,0,0,0,3.49V45.374a3.49,3.49,0,0,0,3.49,3.49H45.374a3.49,3.49,0,0,0,3.49-3.49v-3.49",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1-link-3",
    "data-name": "path-1-link",
    transform: "translate(0 13.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1-3",
    "data-name": "path-1",
    d: "M6.981,0H3.49A3.49,3.49,0,0,0,0,3.49V45.374a3.49,3.49,0,0,0,3.49,3.49H45.374a3.49,3.49,0,0,0,3.49-3.49v-3.49",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M11.49.333H53.374a3.49,3.49,0,0,1,3.49,3.49V45.708a3.49,3.49,0,0,1-3.49,3.49H11.49A3.49,3.49,0,0,1,8,45.708V3.824A3.49,3.49,0,0,1,11.49.333Z",
    transform: "translate(5.594 -0.333)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M13.333,28.226l23.56-23.56",
    transform: "translate(16.024 4.875)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M31.961,17.628V3.667H18",
    transform: "translate(21.771 5.059)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    fillRule: "evenodd"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLections, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Lections.7b66fb14.svg";
export { ForwardRef as ReactComponent };